// import { getArticleDetail } from '@api/news';
import { useRoute, useRouter } from "vue-router";
import { reactive, ref, watchEffect } from "vue";
import { point } from "@utils/pointUtils";
import { get_news_detail_api, name } from "@api/newTemplate";
import { getParam } from "@utils";
import { nowLang } from "@language";

const articleDetail = reactive({
  articleId: "",
  articleTitle: "",
  articleTime: "",
  articleContent: "",
});

export default function () {
  const route = useRoute();
  const router = useRouter();
  const loading = ref(true);
  const backToList = () => {
    point({
      eventName: "click_button",
      eventType: "文章详情",
      eventReason: "返回列表",
    });
    router.push("/list");
  };
  watchEffect(async () => {
    const id = route.query.id as string;
    const language = nowLang.value;

    if (!id) {
      route.path === "/detail" && router.push("/list");
      return;
    }

    point({
      eventName: "view_page",
      eventType: "文章详情_" + id,
    });

    loading.value = true;
    const articleDetailRes = await get_news_detail_api({
      id: Number(id),
      name,
      language,
    });
    if (+articleDetailRes.result === 1) {
      articleDetail.articleId = id;
      articleDetail.articleContent =
        articleDetailRes?.data?.detail?.CONTENT || "";
      articleDetail.articleTitle = articleDetailRes?.data?.detail?.TITLE || "";
      articleDetail.articleTime = (
        articleDetailRes?.data?.detail?.PUBLISH_TIME || ""
      ).slice(0, 10);
    }

    loading.value = false;
  });

  return {
    articleDetail,
    backToList,
    loading,
  };
}
